import {twStyled} from '../ui/twStyled'

const StyledError = twStyled('div')('text-center font-semibold text-fg-error')

export default StyledError
